/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import * as root from './stores/root';

window.root = root;
import '../../src/components/msToaster';

import '../../src/css/material-icons.css';
import './initMaterialIcons';
import { RootSwitch } from './rootSwither';

import { setACWSName } from '../../src/components/msInputAC';
setACWSName(null);

L.Icon.Default.imagePath = '/';
delete L.Icon.Default.prototype._getIconUrl;

ReactDOM.render(
  <Provider {...root}>
    <div id="root" className={location.href.includes('/survey') ? 'root_survey' : ''}>
      <RootSwitch />
    </div>
  </Provider>,
  window.document.getElementById('app-root'),
);
